import type { LiteralUnion } from 'type-fest';

import type { SubEnvironment } from '@change-corgi/core/environment';
import { isPreviewDemoEnvironment } from '@change-corgi/core/environment';

function getOrigin(env: LiteralUnion<SubEnvironment, string>): string {
	// eslint-disable-next-line @change-corgi/no-static-asset-url
	if (env === 'production' || env === 'development' || !env) return 'https://static.change.org';
	if (env === 'staging') return 'https://static.staging-change.org';
	return `https://static.${env}.changeeng.org`;
}

export function getStaticAssetUrl(
	env: LiteralUnion<SubEnvironment, string>,
	pathname: string,
	demoEnvTarget?: string,
): string {
	// Preview demo envs are deployed via ArgoCD and don't have a corresponding static assets domain,
	// so we fall back to the target demo env (e.g. cyan) for asset URLs.
	const resolvedEnv = env && isPreviewDemoEnvironment(env) ? (demoEnvTarget ?? env) : env;
	return `${getOrigin(resolvedEnv)}${pathname}`;
}
